<div [class.loader-hidden]="!show">
  <div class="loader-overlay">
    <div>
      <mdb-spinner spinnerType="big" spinnerColor="blue" *ngIf="show"></mdb-spinner>
    </div>
  </div>
</div>
